const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalkIn1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.355893, 0, 0, 1.355893, -131.567627, -29.281702)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411.25 120.05c21.352 0 38.852-15.398 42.352-35.699h-84.703c3.1523 20.297 21 35.699 42.352 35.699z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.95 63.699h-35.352c-3.5-20.301-21-35.699-42.352-35.699-21.352 0-38.852 15.398-42.352 35.699h-36.746v14h156.8z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.3 163.8h3.5v56.699h14v-56.699h3.5c14 0 25.199-11.199 25.199-24.852v-61.25h-14v61.602c0 5.9492-4.8984 10.852-11.199 10.852h-3.5v-72.453h-14v72.449h-3.5c-5.9492 0-11.199-4.8984-11.199-10.852v-61.598h-14v61.602c0 13.301 11.199 24.5 25.199 24.5z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.2 316.75c5.9492 0 10.852-4.8984 10.852-10.5v-136.15c0-15.051-8.75-28-21.352-34.648v170.45c-0.34766 6.2969 4.5508 10.848 10.5 10.848z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.05 227.5c-5.9492 0-10.5 4.8984-10.5 10.5 0 5.9492 4.8984 10.5 10.5 10.5h48.648c11.199 0 21-7.3516 23.801-17.852l13.648-47.25v-46.547c-8.75 4.8984-15.398 13.301-18.199 23.449l-16.102 60.551c-1.0508 3.8516-4.5508 6.6484-8.75 6.6484z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.8 184.1v127.75c37.801 0.69922 73.5 14 102.2 37.449v-216.3c-3.5-1.0508-7-1.3984-10.852-1.3984h-13.301v33.602l-53.898-0.003906v-33.602h-11.199c-4.5508 0-8.75 0.69922-12.949 2.1016z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.45 255.85v81.898c4.5508-2.8008 9.1016-5.6016 14-8.0508v-73.848z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.3 375.9h225.4s-0.35156-0.35156-0.69922-0.35156c-2.1016-2.4492-4.5508-4.8984-7-7-27.301-26.25-64.051-41.301-102.55-42h-2.8008-1.75-2.4492c-40.949 0.70312-80.148 18.555-108.15 49.352z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.75 467.6c-1.3984-12.602-7-24.148-16.102-33.25-10.852-10.852-25.199-16.801-40.602-16.801-14.699 0-28 5.6016-38.148 14.699-10.148 9.1016-17.148 21.699-18.898 35.699h-34.301l65.102-84.699h-270.55l39.898 84.699h-28l-60.199-129.5-45.148-18.199-5.25 12.949 39.898 16.102 61.949 132.3h40.602v50.398h30.801l41.301-50.398h182.7v-14h-44.801c3.5-20.648 21.352-36.051 43.051-36.398 11.551 0 22.75 4.5508 30.801 12.949 6.3008 6.3008 10.5 14.699 11.898 23.449 0.35156 2.4492 0.69922 4.5508 0.69922 7 0 2.4492-0.35156 4.8984-0.69922 7-3.5 20.301-21.352 36.051-43.051 36.051-5.9492 0-11.551-1.0508-16.801-3.1484-5.25-2.1016-10.148-5.25-14-9.4492-2.8008-2.8008-5.25-5.9492-7-9.4492l-15.398-0.003907c2.8008 7 7 13.648 12.602 19.25 10.852 10.852 25.199 16.801 40.949 16.801 14.699 0 28-5.6016 38.148-14.352 10.148-9.1016 17.148-21.699 18.898-35.699 0.35156-2.4492 0.35156-4.5508 0.35156-7 0-2.4531-0.34766-4.5508-0.69922-7zm-285.25 50.398h-10.5v-36.398h40.25z",
    style: {
      fill: "rgb(27, 98, 171)"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 70, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 82.84375, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 91.47265625, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 103.34375, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 115.15234375, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 123.515625, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 135.38671875, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 154.00390625, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 166.53125, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 184.03125, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 196.63671875, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 208.04296875, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 226.27734375, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 238.8046875, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 250.828125, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 256.828125, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 268.84765625, 612.5)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 70, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 77.61328125, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 86.2421875, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 98.265625, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 122.59375, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 130.9609375, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 143.41796875, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 161.37890625, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 176.0234375, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 188.046875, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 200.5078125, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 219.05859375, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 231.8828125, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 240.515625, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 252.53515625, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 258.53515625, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 270.40234375, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 280.77734375, 630)",
    style: {
      fill: "rgb(27, 98, 171)"
    },
    xlinkHref: "#c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkIn1);
export default __webpack_public_path__ + "static/media/walk-in-1.f146b948.svg";
export { ForwardRef as ReactComponent };